import type {StatsTuple} from "../cdx-models/utils/extended-fields";
import type {StatCounts} from "../cdx-models/field-definitions";

/** Resolve a StatsTuple to total effort. */
export const effortFromTuple = (t: StatsTuple | undefined, fallbackEffort: number): number =>
  t ? t[1] + t[2] * fallbackEffort : 0;

/** Resolve a StatCounts object to total effort. */
export const effortFromCounts = (s: StatCounts | undefined, fallbackEffort: number): number =>
  s ? s.effort + (s.noEffort ?? 0) * fallbackEffort : 0;

/** Get card count from a StatsTuple. */
export const countFromTuple = (t: StatsTuple | undefined): number => (t ? t[0] : 0);

/** Get card count from a StatCounts object. */
export const countFromCounts = (s: StatCounts | undefined): number => (s ? s.count : 0);

/** Resolve a single card's effort, applying fallback when null. */
export const resolveCardEffort = (
  effort: number | null | undefined,
  fallbackEffort: number
): number => effort ?? fallbackEffort;
